// Add banner selectors from any chapter to be hidden
const oldBannerSelectors = `
    [data-test-id="cookie-disclaimer-wrapper"],
    [data-test-id="COOKIE_CONTAINER"],
    [class^="cookie-disclaimer__container__"],
    [class^="cookie-banner__Wrapper"],
    [class^="CookieDisclaimer___cookie-disclaimer"],
    [data-test-id="COOKIE_CONTAINER"],
    [class^=cookieDisclaimer___container___],
    [class^=cookie-disclaimer___container___] {
        display: none !important;
    }
`;

export const hideOldBannerElements = () => {
    const headStyleTag = document.createElement('style');
    headStyleTag.classList.add('protected');
    headStyleTag.innerHTML = oldBannerSelectors;
    document.head.appendChild(headStyleTag);
    return () => {
        if (headStyleTag && headStyleTag.parentElement) {
            headStyleTag.parentElement.removeChild(headStyleTag);
        }
    };
};
